export enum Phase {
	L1 = "L1",
	L2 = "L2",
	L3 = "L3",
	N = "N"
}